document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[id^="A1CleaningModesGlass-"]');

  sections.forEach((section) => {
    const cards = Array.from(section.querySelectorAll('[data-mode-card]'));
    const pill = section.querySelector('[data-mode-pill]');
    const pillLabel = section.querySelector('[data-pill-label]');
    const pillLine = section.querySelector('[data-pill-line]');
    const pillIcon = section.querySelector('[data-pill-icon]');
    const revealItems = section.querySelectorAll('.a1modes-reveal');

    if (!cards.length || !pill) return;

    const defaultCard = cards.find((card) => card.dataset.default === 'true') || cards[0];
    let lockedCard = defaultCard || null;

    function updatePill(card) {
      if (!card) return;

      const label = card.dataset.modeLabel || '';
      const line = card.dataset.modeLine || '';
      const icon = card.dataset.modeIcon || '';
      const glow = card.dataset.modeGlow || '#d7e8ff';

      pill.classList.add('is-switching');

      window.setTimeout(() => {
        if (pillLabel) pillLabel.textContent = label;
        if (pillLine) pillLine.textContent = line;
        if (pillIcon && icon) pillIcon.src = icon;
        pill.style.setProperty('--pill-accent', glow);
        pill.classList.remove('is-switching');
      }, 120);
    }

    function previewCard(card) {
      cards.forEach((item) => item.classList.remove('is-preview'));
      if (card) card.classList.add('is-preview');
      updatePill(card);
    }

    function resetPreview() {
      cards.forEach((item) => item.classList.remove('is-preview'));
      if (lockedCard) updatePill(lockedCard);
    }

    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          previewCard(card);
        }
      });

      card.addEventListener('mouseleave', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          resetPreview();
        }
      });

      card.addEventListener('focus', () => previewCard(card));

      card.addEventListener('click', () => {
        lockedCard = card;
        updatePill(card);
      });
    });

    if (lockedCard) updatePill(lockedCard);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('a1modes-visible');
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.12 });

      revealItems.forEach((item, index) => {
        item.style.transitionDelay = `${Math.min(index * 70, 360)}ms`;
        observer.observe(item);
      });
    } else {
      revealItems.forEach((item) => item.classList.add('a1modes-visible'));
    }
  });
});